export const MessageUsageKind = Object.freeze({
  TEXT: 'TEXT',
  AUDIO_TTS: 'AUDIO_TTS',
})

export const MessageUsageSchema = Object.freeze({
  usageKinds: Object.freeze(Object.values(MessageUsageKind)),
})

const messageUsageKindValues = new Set(MessageUsageSchema.usageKinds)

export function requireMessageUsageKind(value, context = 'message usage kind') {
  if (!messageUsageKindValues.has(value)) {
    throw new Error(`Unsupported ${context}: ${String(value)}`)
  }

  return value
}

export function validateMessageUsageMap(messageUsage) {
  if (messageUsage == null) {
    return {}
  }

  if (typeof messageUsage !== 'object' || Array.isArray(messageUsage)) {
    throw new Error('Invalid message usage payload')
  }

  for (const [usageKind, usage] of Object.entries(messageUsage)) {
    requireMessageUsageKind(usageKind, 'message usage map key')

    if (usage == null || typeof usage !== 'object' || Array.isArray(usage)) {
      throw new Error(`Invalid message usage entry for ${usageKind}`)
    }

    const entryUsageKind = requireMessageUsageKind(
      usage.usageKind,
      `message usage entry kind for ${usageKind}`,
    )
    if (entryUsageKind !== usageKind) {
      throw new Error(`Message usage entry kind mismatch for ${usageKind}`)
    }
  }

  return messageUsage
}
